import { formatCurrency2String } from 'src/utils/number/currency'
import Colors from 'src/components/TreeMap/components/Colors'
import styles from './styles.module.scss'
import { intl } from 'src/i18n'

const colors = new Colors().createScale()

type Props = {
  category: string
  change: number
  code: string
  emission: number
  last24hChange: number
  last24hChangeUsd: number
  last24hVolume: number
  marketCap: number
  marketCapRank: number
  name: string
  price: number
  volume: number
}

const Description = (props: Props) => {
  const { change, code, category, marketCapRank, name } = props

  const colorize = (item, colorPercent: number, backcolor = false) => {
    const color = colors(Math.round(colorPercent * 100) / 100)

    if (backcolor) {
      return (
        <span
          className={styles.formatedBackColor}
          style={{ backgroundColor: color }}
        >
          {item}
        </span>
      )
    }

    return <span style={{ color }}>{item}</span>
  }

  const currency = 'USD'
  const price = colorize(
    `${formatCurrency2String(props.price)} ${currency}`,
    change
  )
  const marketCap = colorize(
    `${formatCurrency2String(props.marketCap, false, '0,0')} ${currency}`,
    change
  )
  const emission = formatCurrency2String(props.emission)
  const last24hVolume = colorize(
    `${formatCurrency2String(props.last24hVolume, false, '0,0')} ${currency}`,
    change
  )
  const last24hChange = colorize(
    `${props.last24hChange.toFixed(2)}%`,
    props.last24hChange,
    true
  )
  const last24hChangeUsd = colorize(
    `${formatCurrency2String(props.last24hChangeUsd)} ${currency}`,
    props.last24hChange
  )

  return (
    <div className={styles.descriptionText}>
      <p>
        {intl.t('coinDetails.aboutBlock.description1', {
          price,
          marketCap,
          emission,
          last24hVolume,
          last24hChange,
          last24hChangeUsd,
          code,
          category,
          marketCapRank,
          name,
        })}
        <span className={styles.marketcapRank}>#{marketCapRank}</span>
        {intl.t('coinDetails.aboutBlock.description2', {
          price,
          marketCap,
          emission,
          last24hVolume,
          last24hChange,
          last24hChangeUsd,
          code,
          category,
          marketCapRank,
          name,
        })}
      </p>
      <p>
        {intl.t('coinDetails.aboutBlock.description3', {
          price,
          marketCap,
          emission,
          last24hVolume,
          last24hChange,
          last24hChangeUsd,
          code,
          category,
          marketCapRank,
          name,
        })}
      </p>
    </div>
  )
}

export const AboutBlock = ({ data }) => {
  const {
    name,
    extra,
    marketCapRank,
    price,
    marketCap,
    volume,
    emission,
    code,
    change,
    category,
    yesterdayData,
  } = data

  return (
    <>
      <h2 className={styles.descriptionHeader}>
        {intl.t('coinDetails.aboutBlock.descriptionHeader', {
          name,
        })}
      </h2>
      <div className={styles.descriptionText}>
        <Description
          category={category}
          change={change}
          code={code}
          emission={emission}
          last24hChangeUsd={yesterdayData?.change_usd || 0}
          last24hChange={yesterdayData?.change || 0}
          last24hVolume={yesterdayData?.volume || 0}
          marketCap={marketCap}
          marketCapRank={marketCapRank}
          name={name}
          price={price}
          volume={volume}
        />
        {extra && extra.description && (
          <div
            className={styles.extraDescriptionWrapper}
            dangerouslySetInnerHTML={{ __html: extra.description }}
          />
        )}
      </div>
    </>
  )
}
